import * as Yup from 'yup';

const apiKeySchema = Yup.object({
  name: Yup.string().required('Name is required'),
});
const serverGuardSchema = Yup.object({
  name: Yup.string().required('Name is required'),
  endpoint: Yup.string()
    .matches(/^(https?:\/\/)[^\s/$.?#].[^\s]*$/i, 'Enter a valid URL')
    .required('Url is required'),
});
const toolGovernanceSchema = Yup.object({
  toolName: Yup.string().required('Name is required'),
});

export { apiKeySchema, serverGuardSchema, toolGovernanceSchema };
